<template>
  <div class="navigation-container">
    <a class="navigation-item"
        v-long-press="500"
        @long-press-start="onLongPressStart"
        @click="navigate('accounts')">
      <navigation-item title="Accounts" :active="currentTab === 'accounts'">
        <icon-accounts />
      </navigation-item>
    </a>
    <a class="navigation-item" href="http://www.cmstechhelp.com" target="_blank">
      <navigation-item title="Tech Help">
        <icon-hammer />
      </navigation-item>
    </a>
    <a class="navigation-item" @click="navigate('settings')">
      <navigation-item title="Settings" :active="currentTab === 'settings'">
        <icon-gear />
      </navigation-item>
    </a>
    <cms-action-sheet
        v-if="showLongPressMenu"
        cancelBtn="Cancel"
        :actions="actions"
        @cancelClick="showLongPressMenu = false"
        @click="onLongPressMenuItemClick"
    />
  </div>
</template>

<script>
import iconHammer from "./icons/hammer";
import iconGear from "./icons/gear";
import iconAccounts from "./icons/accounts";
import navigationItem from "./navigation-item";
import router from "../router";
import LongPress from "vue-directive-long-press"
import { mapActions } from "vuex";

const routes = {
  accounts: "/accounts",
  settings: "/settings"
};

export default {
  name: "cms-navigation",
  directives: {
    'long-press': LongPress
  },
  components: {
    "navigation-item": navigationItem,
    "icon-hammer": iconHammer,
    "icon-gear": iconGear,
    "icon-accounts": iconAccounts
  },
  created() {
    this.$data.currentTab = router.app.$route.meta.area;
  },
  data() {
    return {
      currentTab: null,
      showLongPressMenu: false
    };
  },
  computed: {
    actions() {
      var actions = ["Location Search"];
      return actions;
    },
  },
  methods: {
    ...mapActions(["clearLocation"]),
    navigate(tab) {
      if (this.$data.currentTab === tab) {
        return;
      }
      this.$data.currentTab = tab;
      router.push({ path: routes[tab] });
    },
    onLongPressStart () {
      this.showLongPressMenu = true;
    },
    async onLongPressMenuItemClick() {
      await this.clearLocation();
      if(this.$route.name !== "LocationSearch"){
        router.push({ name: "LocationSearch" });
      }
      this.showLongPressMenu = false;
    }
  }
};
</script>

<style scoped lang="scss">
.navigation-container {
  background-color: $white-two-color;
  border: solid;
  border-width: 1px 0 0 0;
  border-color: rgba(103, 172, 219, 0.5);
  height: 53px;
}

.navigation-item {
  display: inline-block;
  width: 33.3%;
}
</style>
